module.exports = __webpack_public_path__ + "components/country-flag/static/ml-6511c61b93599b95d875791a3584b450.svg";